/* created by CoolGuy on 2018/12/13 */
import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import {IConfigDetail} from '../../global.d';
import VerifyCellphoneModal from './VerifyCellphoneModal';
import CountDownNotification from './CountDownNotification';
import RedPackModalList from './RedPackModalList';
import SendRedPackPage from './SendPack';
import RootStore from '../../store/RootStore';
import RedPackDetail from '../../pages/RedPack/RedPackDetail';
import usePortalDom from '../hooks/usePortalDom';
import { createPortal } from 'react-dom';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

interface IAllRedPackComponents {
  rootStore?: RootStore;
}

// 注意，这个组件请务必在获取了系统时间之后再渲染，否则会出现问题
// 渲染这个组件说明一定是use_package了
function AllRedPackComponents(props: IAllRedPackComponents) {
  const { redPackStore } = props.rootStore!;
  const {
    notificationTime,
    showVerifyModal,
    showNotification,
    currentServerTime,
    showSendModal,
    showRedPackDetailModal
  } = redPackStore;

  useEffect(() => {
    if (showRedPackDetailModal) {
      // @ts-ignore
      disableBodyScroll(document.querySelector('.gallery-home'), {
        allowTouchMove: (el: any) => {
          while (el && el !== document.body) {
            if (el.classList.contains('red-pack-list')) {
              return true;
            }

            el = el.parentNode;
          }
        }
      });
    } else {
      clearAllBodyScrollLocks();
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, [showRedPackDetailModal]);

  const containerEl = usePortalDom({
    parentElement:window.document.getElementById('root-page')! as HTMLElement
  });

  const {use_package} = window.configDetail as IConfigDetail;

  return (containerEl && Number(use_package)) ? createPortal(
    <>
      {showVerifyModal && <VerifyCellphoneModal />}
      {showNotification && !!currentServerTime && (
        <CountDownNotification time={notificationTime} />
      )}
      {/*必须要获取到了服务器时间才能渲染这个组件，否则CountDownNotification会杯具*/}
      {!!currentServerTime && <RedPackModalList />}
      {showSendModal && (
        <div className={'send-red-pack-page-wrapper'}>
          <SendRedPackPage
            style={{ width: 300, borderRadius: 4, overflowY: 'auto' }}
          />
        </div>
      )}
      {showRedPackDetailModal && <RedPackDetail />}
    </>,
    containerEl
  ) : null;
}
export default inject('rootStore')(observer(AllRedPackComponents));
